export default __webpack_public_path__ + "static/media/large.4e5a17ec.jpg";